export default __webpack_public_path__ + "static/media/noa-42.0a7d37d9.jpg";